import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import LoginGate from './LoginGate';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState(location.state?.user ? "authed" : "checking");

  useEffect(() => {
    if (location.state?.user) { setStatus("authed"); return undefined; }
    let cancelled = false;
    async function check() {
      try {
        const res = await fetch(`${API_URL}/api/auth/me`, { credentials: "include" });
        if (!res.ok) throw new Error("unauthorized");
        if (!cancelled) setStatus("authed");
      } catch (err) {
        if (!cancelled) setStatus("denied");
      }
    }
    check();
    return () => { cancelled = true; };
  }, [location.state]);

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#003A70]" />
      </div>
    );
  }
  if (status === "denied") {
    return <LoginGate error={location.state?.authError} />;
  }
  return children;
}
